"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@mapmaker/core");
const react_1 = __importDefault(require("react"));
const MatImageFillFilter_1 = require("./MatImageFillFilter");
/*
 * Renders a path (usually a compound path) of a layer with the openings cut out (eg. a piece of
 * matboard which would be cut).
 */
function Mat({ design, layer, strokeWidth = 0, fill = "#FFFFFF", fillUrl, fillColor, filter, exclude = false, }) {
    if (exclude) {
        return null;
    }
    function getCompoundPathIncludingChildren(nodeData) {
        var _a;
        var compoundPath = "";
        if (nodeData.d) {
            compoundPath += nodeData.d;
        }
        if (((_a = nodeData.children) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            compoundPath += nodeData.children.reduce((childrenPath, child) => {
                return childrenPath + getCompoundPathIncludingChildren(child);
            }, compoundPath);
        }
        return compoundPath;
    }
    function getPath() {
        const w = design.width;
        const h = design.height;
        const layers = (0, core_1.getFeaturesList)(design, "OPENING")
            .map((feature) => feature.layout[layer])
            .filter(layer => layer);
        if (layers.length === 0 && layer !== "background") {
            return null;
        }
        const path = layers.reduce((path, layer) => {
            return path + getCompoundPathIncludingChildren(layer);
        }, `M 0 0 L ${w} 0 L ${w} ${h} L 0 ${h} L 0 0 z`);
        return path;
    }
    const path = getPath();
    const fillId = `${layer}-print`;
    if (!path) {
        return null;
    }
    else {
        function FillFilter() {
            if (fillUrl) {
                return (react_1.default.createElement(MatImageFillFilter_1.MatImageFillFilter, { id: fillId, url: fillUrl, fill: fillColor }));
            }
            else {
                return null;
            }
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(FillFilter, null),
            react_1.default.createElement("path", { filter: filter, style: {
                    fill: fillUrl ? `url(#${fillId})` : fillColor !== null && fillColor !== void 0 ? fillColor : fill,
                    fillRule: "evenodd",
                    stroke: "RGBA(0,0,0,0.6)",
                    strokeWidth: strokeWidth * 0,
                    vectorEffect: "non-scaling-stroke",
                }, d: getPath() })));
    }
}
exports.default = Mat;
//# sourceMappingURL=data:application/json;base64,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